module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_2023-bd21ad8674c1eb0232034dca104305df.png";